import type React from 'react';
import { Button, ButtonGroup, Paragraph, TextButton } from '@zillow/constellation-10';
import Modal from '@common/components/ConstellationV10Modal';
import userPersonas from '@common/constants/userPersonas';

type Props = {
  exitPaymentSetup: () => void;
  onBack: () => void;
};

const ExitPaymentSetup: React.FC<React.PropsWithChildren<Props>> = (props: Props): React.ReactElement => {
  return (
    <Modal
      persona={userPersonas.LANDLORD}
      size={{ base: 'fullScreen', md: 'xs' }}
      onRequestClose={props.onBack}
      header="Exit without saving?"
      body={<Paragraph>If you leave now, your progress won’t be saved and you’ll need to start over.</Paragraph>}
      footer={
        <ButtonGroup aria-label="Exit payment setup actions">
          <TextButton onClick={props.onBack}>Cancel</TextButton>
          <Button emphasis="filled" onClick={props.exitPaymentSetup}>
            Exit without saving
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default ExitPaymentSetup;
